const PRODUCT_STEPS = Object.freeze({
    description: 'Description',
    customiseText: 'Customise Text',
    iconSelection: 'Icon Selection',
    imageOptions: 'Image Options',
    approval: 'Approval'
});

export default PRODUCT_STEPS;
